/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
// @material-ui/icons
import Clear from "@material-ui/icons/Clear";
import Check from "@material-ui/icons/Check";
// core components
import styles from "assets/jss/material-dashboard-react/components/customInputStyle.js";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function CustomInput(props) {
  const [old, setOld] = useState("");
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    id,
    labelProps,
    inputProps,
    error,
    success,
    onChange,
    onKeyDown,
    value,
    integerNumber,
    numberOnly,
    numericInput,
    isSearch
  } = props;

  const [year, setYear] = useState([]);
  const history = useHistory();

  function handleClick(e) {
    if (e.target.value !== "") {
      var obj1 = JSON.stringify(year[0]);
      var obj2 = JSON.stringify(year[1]);
      var obj3 = JSON.stringify(year[2]);
      var obj4 = JSON.stringify(year[3]);
      var obj5 = JSON.stringify(year[4]);
      var obj6 = JSON.stringify(year[5]);

      history.push(
        "/admin/table?search=" +
          e.target.value +
          "&year1=" +
          obj1 +
          "&year2=" +
          obj2 +
          "&year3=" +
          obj3 +
          "&year4=" +
          obj4 +
          "&year5=" +
          obj5 +
          "&year6=" +
          obj6
      );
    }
  }

  useEffect(() => {
    fetch("/api/v1/year/")
      .then(response => response.json())
      .then(
        result => {
          setYear(result);
        },
        error => {
          console.log(error);
        }
      );
  }, []);

  function handleChange(e) {
    if (onChange) {
      props.onChange(e.target.value);
    }

    if (integerNumber) {
      //console.log(e.target.value);
      var last = e.target.value.slice(-1);
      //console.log(last);
      if (
        ((!Number(e.target.value) &&
          e.target.value !== "0" &&
          e.target.value !== "-" &&
          e.target.value !== "0.") ||
          last === ".") &&
        e.target.value !== ""
      ) {
        props.onChange(old);
        //console.log(1);
      } else if (e.target.value === "") {
        //console.log(2);
        setOld(e.target.value);
        props.onChange(e.target.value);
      } else {
        //console.log(3);
        setOld(e.target.value);
        props.onChange(e.target.value);
      }
    }

    if (numberOnly) {
      if (!Number(e.target.value) && e.target.value !== "") {
        props.onChange(old);
      } else if (e.target.value === "") {
        //console.log(1);
        setOld(e.target.value);
        props.onChange(e.target.value);
      } else {
        setOld(e.target.value);
        props.onChange(e.target.value);
      }
    }

    if (numericInput) {
      if (
        !Number(e.target.value) &&
        e.target.value !== "0" &&
        e.target.value !== "-" &&
        e.target.value !== "0." &&
        e.target.value !== ""
      ) {
        props.onChange(old);
      } else if (e.target.value === "") {
        setOld(e.target.value);
        props.onChange(e.target.value);
      } else {
        setOld(e.target.value);
        props.onChange(e.target.value);
      }
    }
  }

  const handleKeyDown = evt => {
    if (evt.key === "Enter" && isSearch && evt.target.value !== "") {
      handleClick(evt);
    }
  };

  const handleKeyDown2 = evt => {
    if (evt.key === "Enter" && evt.target.value !== "") {
      if (onKeyDown) props.onKeyDown(evt);
    }
  };

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error
  });
  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true
  });
  const marginTop = classNames({
    [classes.marginTop]: labelText === undefined
  });
  return (
    <FormControl
      {...formControlProps}
      className={formControlProps.className + " " + classes.formControl}
    >
      {labelText !== undefined ? (
        <InputLabel
          className={classes.labelRoot + labelClasses}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </InputLabel>
      ) : null}
      <Input
        classes={{
          root: marginTop,
          disabled: classes.disabled,
          underline: underlineClasses
        }}
        id={id}
        onChange={handleChange}
        value={value}
        {...inputProps}
        style={{ fontFamily: '"Sarabun", sans-serif' }}
        onKeyDown={isSearch ? handleKeyDown : handleKeyDown2}
      />
      {error ? (
        <Clear className={classes.feedback + " " + classes.labelRootError} />
      ) : success ? (
        <Check className={classes.feedback + " " + classes.labelRootSuccess} />
      ) : null}
    </FormControl>
  );
}

CustomInput.propTypes = {
  labelText: PropTypes.node,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  error: PropTypes.bool,
  success: PropTypes.bool
};
